import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import HomePageSlider from '@/components/HomePageSlider.vue';
import ContactUsForm from '@/components/ContactUsForm.vue';
import GoogleMap from '@/components/GoogleMap.vue';
import OrganizationDescription from '@/components/OrganizationDescription.vue';
import OurValues from '@/components/OurValues.vue';
import PartnersList from '@/components/PartnersList.vue';
import PostsList from '@/components/PostsList.vue';

import { useGlobalStore, useConfigStore } from '@/stores';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const $route = useRoute();

const globalStore = useGlobalStore();
const configStore = useConfigStore();

onMounted(() => {
  globalStore.createVisit(
    $route.path,
    configStore.locale == 'ar' ? 'الصفحة الرئيسية' : 'Home Page'
  );
});

return (_ctx: any,_cache: any) => {
  const _component_WebsiteLayout = _resolveComponent("WebsiteLayout")!

  return (_openBlock(), _createBlock(_component_WebsiteLayout, null, {
    content: _withCtx(() => [
      _createVNode(HomePageSlider),
      _createVNode(OrganizationDescription),
      _createVNode(OurValues),
      _createVNode(PostsList, { type: "events" }),
      _createVNode(PostsList, { type: "news" }),
      _createVNode(PartnersList),
      _createVNode(ContactUsForm),
      _createVNode(GoogleMap)
    ]),
    _: 1
  }))
}
}

})